import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row" }
const _hoisted_2 = {
  style: {"z-index":"1"},
  class: "d-flex flex-column justify-center mr-2"
}
const _hoisted_3 = { class: "caret-container" }
const _hoisted_4 = {
  style: {"z-index":"1"},
  class: "d-flex flex-column justify-center ml-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_VTextFieldFilled = _resolveComponent("VTextFieldFilled")!

  return (_openBlock(), _createBlock(_component_VTextFieldFilled, {
    modelValue: _ctx.nmbr,
    "onUpdate:modelValue": [
      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nmbr) = $event)),
      _ctx.change
    ],
    label: _ctx.label,
    rules: _ctx.rules,
    class: "number-input",
    type: "text",
    readonly: _ctx.readonly,
    "hide-details": _ctx.hideDetails,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    density: _ctx.density
  }, _createSlots({
    "append-inner": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "pre-append", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_icon, {
            icon: "$fa-caret-up",
            size: "x-small",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.increment()), ["stop"])),
            class: _normalizeClass({ 'cursor-pointer': !_ctx.disabled })
          }, null, 8, ["class"]),
          _createVNode(_component_v_icon, {
            icon: "$fa-caret-down",
            size: "x-small",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (!_ctx.readonly && _ctx.decrement()), ["stop"])),
            class: _normalizeClass({ 'cursor-pointer': !_ctx.disabled })
          }, null, 8, ["class"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "post-append", {}, undefined, true)
        ])
      ])
    ]),
    _: 2
  }, [
    (_ctx.$slots.append)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "append", {}, undefined, true)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.prepend)
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "prepend", {}, undefined, true)
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["modelValue", "label", "rules", "readonly", "hide-details", "placeholder", "disabled", "onUpdate:modelValue", "density"]))
}